// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'
import moment from 'moment'
import EnhanceComposer from './EnhanceComposer'
import BannedInstagram from './BannedInstagram'
// import InstaHashtagCommenter from './InstaHashtagCommenter'
import Deposit from './ritekit/Deposit'
import ReportCheckout from './ritekit/ReportCheckout'
import HashtagReport from './ritetag/HashtagReport'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import VueClipboard from 'vue-clipboard2'
import * as uiv from 'uiv'
import round from 'vue-round-filter'
import {VueMasonryPlugin} from 'vue-masonry'
import ToggleButton from 'vue-js-toggle-button'

Vue.use(uiv, {prefix: 'b'})
Vue.use(Notifications, {velocity})
Vue.use(VueClipboard)
Vue.use(VueMasonryPlugin)
Vue.use(ToggleButton)
// Raven
//     .config('https://090e69837fe345d5a7a33cb5ce6d2653@sentry.io/1234914')
//     .addPlugin(RavenVue, Vue)
//     .install()

Vue.filter('round', round)
Vue.filter('formatDate', (value) => {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY hh:mma')
    }
})
Vue.filter('formatBigNumbers', (value, precision) => {
    value = Number(value)
    if (Number.isNaN(value)) {
        return ''
    }
    let abb = ''
    const l10 = Math.log10(value)
    if (l10 >= 9) {
        abb = 'B'
        value = value / 1e9
    } else if (l10 >= 6) {
        abb = 'M'
        value = value / 1e6
    } else if (l10 >= 3) {
        abb = 'k'
        value = value / 1e3
    }
    const p = Math.pow(10, precision)
    const result = Math.round(value * p) / p
    return result + abb
})

Vue.config.productionTip = false

/* eslint-disable no-new */
if (document.getElementById('enhance-composer')) {
    new Vue({
        el: '#enhance-composer',
        template: '<EnhanceComposer />',
        components: {EnhanceComposer}
    })
}
if (document.getElementById('banned-instagram')) {
    new Vue({
        el: '#banned-instagram',
        // switched to render my component for testing
        template: '<BannedInstagram />',
        components: {BannedInstagram}
    })
}
if (document.getElementById('deposit')) {
    new Vue({
        el: '#deposit',
        template: '<Deposit />',
        components: {Deposit}
    })
}
if (document.getElementById('reportCheckout')) {
    new Vue({
        el: '#reportCheckout',
        template: '<ReportCheckout />',
        components: {ReportCheckout},
        data () {
            return {
                price: document.getElementById('reportCheckout').dataset.price,
                query: JSON.parse(document.getElementById('reportCheckout').dataset.query)
            }
        }
    })
}

const element = document.getElementById('ritetag-hashtag-report')
if (element) {
    const data = {
        hashtag: element ? element.dataset.hashtag : '',
        uuid: element ? element.dataset.uuid : null,
        loggedIn: element ? element.dataset.loggedIn : false
    }

    new Vue({
        el: '#ritetag-hashtag-report',
        template: '<HashtagReport />',
        components: {HashtagReport},
        data () {
            return data
        }
    })
}



// WEBPACK FOOTER //
// ./src/main.js